import { render, staticRenderFns } from "./AppSubmenu.vue?vue&type=template&id=490b112d&"
import script from "./AppSubmenu.vue?vue&type=script&lang=js&"
export * from "./AppSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports